<template>
<div class="hl-wid ww1 wh1 wt0 hl-search">
  <div class="logo"></div>
  <vue-autosuggest
    :value="value"
    v-on:input="$emit('input', $event)"
    v-on:selected="selectItem($event)"
    :suggestions="[{data: suggestions}]"
    :input-props="{id:'autosuggest__input', placeholder:'Search'}"
    :get-suggestion-value="getSuggestionValue" >
    <template slot-scope="{suggestion}">
      <span class="suggestion-item">{{getSuggestionValue(suggestion)}}</span>
    </template>
  </vue-autosuggest>
</div>
</template>

<script>
import mainNav from './mainNav';

export default {
  props: ["value"],
  data: ()=>({
    teachers: [],
  }),
  computed: {
    suggestions() {
      var result=[];
      if (!this.value)
        return result;
      for(var teacher of this.teachers) {
        teacher.type='teacher';
        result.push(teacher);
      }
      for(var item of this.tags.aparatus) {
        item.type='aparatus';
        result.push(item);
      }
      for(var item of this.tags.props) {
        item.type='prop';
        result.push(item);
      }
      for(var item of this.tags.specialities) {
        item.type='speciality';
        result.push(item);
      }
      result=result.filter((a)=>{
        return ((this.getSuggestionValue({item: a}) || "").toLowerCase().indexOf(this.value.toLowerCase())!=-1);
      });
      return result;
    },
  },
  methods: {
    selectItem($event) {
      if ($event.item.type=='teacher')
        this.$router.push({name: "content.teacher", params: {id: $event.item.username}});
      if ($event.item.type=='aparatus')
        this.$router.push({name: "categoryfilter", params: {category: 'all', filter: "a="+$event.item.id}});
      if ($event.item.type=='prop')
        this.$router.push({name: "categoryfilter", params: {category: 'all', filter: "p="+$event.item.id}});
      if ($event.item.type=='speciality')
        this.$router.push({name: "categoryfilter", params: {category: 'all', filter: "s="+$event.item.id}});
    },
    getSuggestionValue(val) {
      if (val.item.type=='teacher')
        return val.item.pubname || (val.item.firstname+" "+val.item.lastname);
      else
        return val.item.title;
    },
    async loadTeachers() {
      this.teachers=(await api.list("User", {teacher: 1}, ["id:DESC"])).items;
    },
    async doLoadTags() {
      await this.loadTags();
      if (this.$route.params.filter) {
        var f=this.$route.params.filter;
        if (f.startsWith("a=")) {
          for(var item of this.tags.aparatus)
            if (item.id==f.substring(2)*1)
              this.$emit('input', item.title);
        } else if (f.startsWith("p=")) {
          for(var item of this.tags.props)
            if (item.id==f.substring(2)*1)
              this.$emit('input', item.title);
        } else if (f.startsWith("s=")) {
          for(var item of this.tags.specialities)
            if (item.id==f.substring(2)*1)
              this.$emit('input', item.title);
        }
      }
    },
  },
  mounted() {
    this.loadTeachers();
    this.doLoadTags();
  },
  mixins: [mainNav],
}
</script>
